import { render, staticRenderFns } from "./sales-filter.vue?vue&type=template&id=b5346242"
import script from "./sales-filter.vue?vue&type=script&lang=js"
export * from "./sales-filter.vue?vue&type=script&lang=js"
import style0 from "./sales-filter.vue?vue&type=style&index=0&id=b5346242&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports